export const SIGN_IN_FORM_EMAIL_PLACEHOLDER = 'sign-in-form.email-placeholder';
export const SIGN_IN_FORM_PASSWORD_PLACEHOLDER = 'sign-in-form.password-placeholder';
export const SIGN_IN_FORM_REMEMBER_ME_LABEL = 'sign-in-form.remember-me-label';
export const SIGN_IN_FORM_FORGOT_PASSWORD = 'sign-in-form.forgot-password';
export const SIGN_IN_FORM_SUBMIT_BUTTON_LABEL = 'sign-in-form.submit-button-label';
export const SIGN_IN_FORM_EMAIL_INVALID_ERROR_MESSAGE = 'sign-in-form.email-invalid-error-message';
export const SIGN_IN_FORM_PASSWORD_REQUIRED_ERROR_MESSAGE = 'sign-in-form.password-required-error-message';
export const SIGN_IN_FORM_CREDENTIALS_INCORRECT_ERROR_MESSAGE = 'sign-in-form.credentials-incorrect-error-message';
